import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { validateStaff, setStaffSession } from "../../utils/staffAuth";
import GoogleSignInModal from "../../components/homepage/GoogleSignInModal";
import "./BillingLogin.css";

function BillingLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showGoogleModal, setShowGoogleModal] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    const user = validateStaff(username.trim(), password);
    if (user && user.role === "billing") {
      setStaffSession(user);
      navigate("/billing", { replace: true });
    } else if (user) {
      setError("Access denied. Billing login only.");
    } else {
      setError("Invalid credentials.");
    }
  };

  return (
    <div className="billing-login-page">
      <div className="billing-login-card">
        <h1 className="billing-login-title">Billing Access</h1>
        <p className="billing-login-subtitle">Swastik Hospital – Authorized billing staff only.</p>
        <form className="billing-login-form" onSubmit={handleSubmit}>
          <div className="billing-login-field">
            <label htmlFor="billing-username">Username</label>
            <input
              id="billing-username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Username"
              required
              autoComplete="username"
            />
          </div>
          <div className="billing-login-field">
            <label htmlFor="billing-password">Password</label>
            <input
              id="billing-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              required
              autoComplete="current-password"
            />
          </div>
          {error && <p className="billing-login-error">{error}</p>}
          <button type="submit" className="billing-login-btn">Sign in</button>

          <div style={{ display: 'flex', alignItems: 'center', margin: '1.25rem 0', gap: '1rem', color: '#94a3b8' }}>
            <div style={{ flex: 1, height: '1px', background: '#e2e8f0' }}></div>
            <span style={{ fontSize: '0.8rem', fontWeight: 600 }}>OR</span>
            <div style={{ flex: 1, height: '1px', background: '#e2e8f0' }}></div>
          </div>

          <button
            type="button"
            className="google-login-btn"
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              padding: '0.75rem',
              borderRadius: '10px',
              border: '1.5px solid #e2e8f0',
              background: '#fff',
              fontSize: '0.9rem',
              fontWeight: 600,
              color: '#334155',
              cursor: 'pointer'
            }}
            onClick={() => setShowGoogleModal(true)}
          >
            <svg viewBox="0 0 24 24" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.63z" fill="#FBBC05" />
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.47 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z" fill="#EA4335" />
            </svg>
            <span>Sign in with Google</span>
          </button>
        </form>
        <p className="billing-login-footer">Session secured. Unauthorized access is prohibited.</p>
      </div>

      {showGoogleModal && (
        <GoogleSignInModal
          roleName="Billing"
          roleValue="billing"
          onClose={() => setShowGoogleModal(false)}
          onFailure={(errMessage) => setError(errMessage)}
        />
      )}
    </div>
  );
}

export default BillingLogin;
